import { combineReducers } from 'redux';
import anomalyDailyReport from './anomalyDailyReport';

export default combineReducers({
  anomalyDailyReport
});
